<template>
<ct-popover trigger="hover" placement="bottom">
  <span slot="popper">
    {{text}}
    <div class="popper__arrow" style="left:calc(50% - 9px);border-color: transparent transparent #fff  transparent;z-index:1;"></div>
  </span>
  <span class="comments-button" :class="active" slot="reference" @click="$emit('click', $event)">
    <slot></slot>
    <span class="line"></span>
    <span class="dis-inline">{{value}}</span>
  </span>
</ct-popover>

</template>
<script>
import CtPopover from '@ca/components/CtPopover'
export default {
  name: 'CommentButton',
  components: {
    'ct-popover': CtPopover
  },
  props: {
    'active': String,
    'dis-inline': {
      type: Number,
      required: true
    },
    'dis-none': {
      type: String,
      default: '',
      required: true
    }
  },
  computed: {
    value () {
      return this.disInline
    },
    text () {
      return this.disNone
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/_varaible.scss';

$border-color: #DAE0E5;
.no-margin{
.comments-button{
  margin-left: 0;

}
}
.comments-button{
  margin-left: 10px;
  position: relative;
  text-align: center;
  display: inline-block;
  vertical-align: middle;
  min-width:80px;
  height:32px;
  padding: 0 6px;
  line-height:30px;
  background:#fff;
  border-radius:2px;
  color: $border-color;
  border:1px solid ;
  cursor: pointer;
  transition: color .3s ease-out;
  &.active{
    transition: color .3s ease-out;
    color: $secondary;
    .line{
      transition: background-color .3s ease-out;
      background-color: $secondary;
    }
  }
  .line{
    display: inline-block;
    vertical-align: middle;
    border-radius:2px;
    margin: 0 8px;
    height: 16px;
    width: 1px;
    background-color: $border-color;
    transition: background-color .3s ease-out;
  }
  .dis-inline{
    display: inline-block;
    vertical-align: middle;
    font-size:16px;
    font-family:SFProDisplay-Regular;
    font-weight:400;
    color:$secondary;
  }
}
</style>
